// Hook para importar instrumentos desde un archivo Excel
import { useApi, createApiHook } from "../utils/apiUtils";

const useImportInstrumentFromExcel = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const importFromExcel = async (file, instrumentName) => {
    if (!file) return { ok: false };

    startLoading();

    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", instrumentName);

    const response = await apiPost("/instruments/create_instrument_questionnaires", "Error al subir el archivo Excel", formData, {
      "Content-Type": "multipart/form-data",
    });

    setResponse(response);

    return {
      data: response?.data,
      status: response?.status,
      errorMessage: response?.error,
    };
  };

  return { importFromExcel, data, error, loading };
};

export default useImportInstrumentFromExcel;
